import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { SortOrder } from "interfaces/SortOrder";

export const user = (id: string): racehorse360.IGetUserRequest => ({
  id,
  getOptions: {
    select: ["firstName", "lastName", "email", "licenseNumber", "phoneNumber"]
  }
});

export const userRoles = (
  userId: string
): racehorse360.IListUserRolesRequest => ({
  query: {
    userIds: [userId]
  },
  pagingOptions: {
    maxResults: 20 // arbitrary.. should be enough for now
  },
  getOptions: {
    select: [
      "facility.name",
      "role.name",
      "role.roleType",
      "trainer.firstName",
      "trainer.lastName",
      "trainer.type",
      "user.firstName",
      "user.lastName",
      "user.email",
      "user.licenseNumber",
      "user.phoneNumber"
    ]
  }
});

export const facilities: racehorse360.IListFacilitiesRequest = {
  query: {
    isActive: { value: true }
  },
  pagingOptions: {
    maxResults: 20 // arbitrary.. should be enough for now
  },
  getOptions: {
    select: ["name", "code", "type"],
    orderBy: ["name"]
  }
};

export const roles: racehorse360.IListRolesRequest = {
  query: {},
  pagingOptions: {
    maxResults: 20 // arbitrary.. should be enough for now
  },
  getOptions: {
    select: ["name", "roleType"],
    orderBy: ["name"]
  }
};

export const trainers = (
  trainerName: string
): racehorse360.IListTrainersRequest => ({
  query: {
    fullName: {
      contains: trainerName
    }
  },
  pagingOptions: {
    maxResults: 20 // arbitrary.. should be enough for now
  },
  getOptions: {
    select: ["firstName", "lastName", "type"],
    orderBy: [`fullName ${SortOrder.ASC}`]
  }
});
